import { EmailIssue, Partner } from 'types';
import checkIsValidEmail from 'utils/checkIsValidEmail';

const getInvalidEmails = (partners: Partial<Partner>[]): EmailIssue[] => {
  const result: EmailIssue[] = [];

  partners.forEach((partner) => {
    const name = partner?.name || '';
    const email = partner?.email || '';

    const validEmail = checkIsValidEmail(email);
    if (!validEmail) {
      result.push({ name, email });
    }
  });
  return result;
};

export default getInvalidEmails;
